export type { AlertDialogProps } from './alert-dialog';
export { AlertDialog } from './alert-dialog';
